<template>
  <div class="header">
    <div class="logoBox">
      <img class="logo"
           @click="toHome"
           :src="require('../../static/image/logo.png')"
           alt=""
           srcset="">
    </div>
    <TopBar></TopBar>
  </div>
</template>

<script>
import TopBar from './TopBar'
export default {
  name: 'Header',
  components: {
    TopBar
  },
  methods: {
    toHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scope>
@import "@/styles/function.scss";
.header {
  display: flex;
  width: 100%;
  background-color: #572433;
  height: px(230);
  margin: 0 auto;
  .logoBox {
    width: px(655);
    position: relative;
    .logo {
      display: block;
      width: px(212);
      height: px(171);
      position: absolute;
      top: px(60);
      left: 50%;
      transform: translateX(-50%);
      // margin-right: px(225);
      // margin-top: px(60);
      // margin-bottom: px(95);
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue